// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".custom-dept-plant label {\n  padding: 0px !important;\n}\n.custom-dept-plant label .q-field__inner {\n  padding: 0px !important;\n}", ""]);
// Exports
module.exports = exports;
